import { render, staticRenderFns } from "./AdminTableDisplay.vue?vue&type=template&id=309a0f4b&scoped=true"
import script from "./AdminTableDisplay.vue?vue&type=script&lang=js"
export * from "./AdminTableDisplay.vue?vue&type=script&lang=js"
import style0 from "./AdminTableDisplay.vue?vue&type=style&index=0&id=309a0f4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309a0f4b",
  null
  
)

export default component.exports